import { SET_MAP_PROVIDER } from './types';

export const setMapProvider = mapProvider => ({
  type: SET_MAP_PROVIDER,
  mapProvider,
});

export default setMapProvider;
